"use client";

import { useEffect } from "react";

import { X } from "lucide-react";

import { useMessageBar } from "@repo/ui/contexts/MessageBarContext";

export default function MessageBar({
  children,
  hasClose,
}: {
  children: React.ReactNode;
  hasClose?: boolean;
}) {
  const { isVisible, setIsVisible } = useMessageBar();

  // Reset visibility when component mounts (for page navigation)
  useEffect(() => {
    setIsVisible(true);
  }, [setIsVisible]);

  if (!isVisible) return null;

  return (
    <div
      className="fixed top-16 lg:top-14 xl:top-18 z-50 bg-brand-cyan w-full pt-2 pb-2 text-white shadow-lg"
      data-testid="message-bar"
    >
      <div className="relative flex items-center justify-center px-4 text-sm">
        <div className="flex items-center gap-2 max-w-[1200px] mx-auto">{children}</div>

        {hasClose && (
          <button
            onClick={() => setIsVisible(false)}
            aria-label="Dismiss message"
            className="absolute right-4 rounded-full p-1"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
